import NotificationMixin from 'Support/mixins/notification-mixin';
import RouterMixin from 'Support/mixins/router-mixin';

export default {
  mixins: [NotificationMixin, RouterMixin],
  data: () => ({
    showSuccessToastMessage: true,
    successToasMessage: 'Relatório gerado com sucesso.',
    formsRef: 'form',
    formValid: false,
    loadingForm: false,
    fileName: 'relatorio',
  }),
  methods: {
    validateForm() {
      return this.$refs[this.formsRef].validate();
    },
    downloadFile(blob, fileName) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.append(link);
      link.click();
      link.remove();
      window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
    },
    generate() {
      if (!this.validateForm()) {
        this.showErrorToast({
          text: 'Existem erros no formulário.',
        });
        return;
      }
      this.loadingForm = true;
      this.requestClass.generate(this.getPayload()).then((reportBlob) => {
        if (this.showSuccessToastMessage) {
          this.showSuccessToast({
            text: this.successToasMessage,
          });
        }
        this.downloadFile(reportBlob, this.fileName);
        this.afterGenerate();
      }).catch(({ response }) => {
        this.showMessageError(response);
      }).finally(() => {
        this.loadingForm = false;
      });
    },
    afterGenerate() {
      if (this.navigateToPageAfter) {
        this.navigateTo(this.navigateToPageAfter);
      }
    },
    showMessageError(response) {
      const { data } = response;
      this.showErrorToast({
        text: data.message || 'Falha ao se comunicar com o servidor.',
      });
    },
  },
};
